import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { Zoom, Fade, Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    TableBody,
    Table,
    TableContainer,
    TableRow,
    TableCell,
    Avatar,
    colors,
    Paper,
    Tooltip,
    Chip,
    FormControl,
    Select,
    MenuItem,
    TableHead,
    Link
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {

    },
    imgviewer1: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: colors.cyan[300],
        width: '100%',
        height: '100%',
    },
    avatar1: {
        color: colors.cyan[300],
        backgroundColor: colors.green[50],
        border: `1px dashed ${colors.green[500]}`,
        minHeight: 600,
        maxHeight: 600

    },
    imgviewer2: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
        color: colors.cyan[300],
        maxWidth: 230,
        maxHeight: 440
    },
    avatar2: {
        color: colors.cyan[300],
        backgroundColor: colors.green[50],
        border: `1px dashed ${colors.green[500]}`,
        width: 230,
        height: 440,
        maxWidth: 230,
        maxHeight: 440
    },
    doctitle1: {
        letterSpacing: '-0.05px',
        backgroundColor: colors.green[300],
        color: colors.common.black,
        marginBottom: -8,
        marginLeft: 10
    },
    doctitle2: {
        letterSpacing: '-0.05px',
        paddingLeft: 5,
        paddingBottom: 0,
        paddingTop: -2,
        color: colors.blue[800]
    },
    doctitle3: {
        letterSpacing: '-0.05px',
        backgroundColor: colors.green[300],
        color: colors.common.white,
        marginLeft: 3
    },
    table: {
        maxHeight: 460
    }
}));

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import PublishIcon from '@material-ui/icons/Publish';
import GetApp from '@material-ui/icons/GetApp';
import EditRoundedIcon from '@material-ui/icons/EditRounded';

var tipos = [
    { id: "ARTIE", name: "ART de Iluminação de Emergência" },
    { id: "ARTE", name: "ART Elétrica" },
    { id: "ARTH", name: "ART Hidraulica" },
    { id: "Foto", name: "Foto" },
    { id: "Imagem", name: "Imagem" },
    { id: "LE", name: "Laudo de Elétrica" },
    { id: "LH", name: "Laudo de Hidraulica" },
    { id: "LIE", name: "Laudo de Iluminação de Emergência" },
    { id: "LSPDA", name: "Laudo de SPDA" },
    { id: "Outros", name: "Outros" }
];

const getName = (tipo) => {
    var index = 0;
    for (let index = 0; index < tipos.length; index++) {
        const element = tipos[index];
        if (element.id == tipo) {
            return tipos[index].name;
        }
    }
}

const fileSize = (bytes) => {
    var exp = Math.log(bytes) / Math.log(1024) | 0;
    var result = (bytes / Math.pow(1024, exp)).toFixed(2);
    return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
}

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Infra = ({ item, open, closeEdition, updateValues, openUpload, openDocumentEdition, selectedMode, infraDocument, changeDocumentInfra, openDeletion, infoValues, changeItem }) => {

    const classes = useStyles();

    var slideRef = {};

    const [docIndex, setDocIndex] = useState(0);

    const defaultProperties = {
        duration: 6000,
        transitionDuration: 1000,
        infinite: true,
        indicators: false,
        arrows: false,
        autoplay: false,
        pauseOnHover: false,
        onChange: (oldIndex, newIndex) => {
            setDocIndex(newIndex);
            changeDocumentInfra(item.docs[newIndex])
        },
        prevArrow: <div style={{ width: "30px", marginRight: "-30px" }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff"><path d="M242 180.6v-138L0 256l242 213.4V331.2h270V180.6z" /></svg></div>,
        nextArrow: <div style={{ width: "30px", marginLeft: "-30px" }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff"><path d="M512 256L270 42.6v138.2H0v150.6h270v138z" /></svg></div>
    }

    const next = (values) => {
        slideRef.current.goNext();
    }

    const previous = (values) => {
        slideRef.current.goBack();
    }

    if (infraDocument === null) {
        if (item && item.docs && item.docs.length > 0) {
            changeDocumentInfra(item.docs[0]);
        }
    }

    return (
        <Fragment>
            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Infraestrutura
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                nome: Yup.string().max(50).required('Nome é obrigatório'),
                                qtd: Yup.number().min(1).max(60000).required('Quantidade de Elementos de Infraestrutura é obrigatória')
                            })
                        }

                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit} >

                                <Box my={2}>

                                    <Grid
                                        container
                                        spacing={2}
                                    >

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <Grid
                                                container
                                                spacing={2}
                                            >

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>

                                                    <TextField
                                                        error={Boolean(touched.nome && errors.nome)}
                                                        required
                                                        fullWidth
                                                        label="Nome"
                                                        margin="none"
                                                        name="name"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.nome}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ readOnly: true }}
                                                    />

                                                </Grid>

                                                <Grid
                                                    item
                                                    md={8}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.tipo && errors.tipo)}
                                                        fullWidth
                                                        required
                                                        label="Tipo de Infraestrutura"
                                                        margin="none"
                                                        name="tipo"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.tipo.nome}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={4}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.qtd && errors.qtd)}
                                                        fullWidth
                                                        label="Quantidade"
                                                        margin="none"
                                                        name="qtd"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.qtd}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>
                                                    <TextField
                                                        error={Boolean(touched.detalhes && errors.detalhes)}
                                                        fullWidth
                                                        label="Observações"
                                                        rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 5 : 2}
                                                        multiline
                                                        margin="none"
                                                        name="detalhes"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.detalhes}
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}>

                                                    <Paper>

                                                        <TableContainer component={PerfectScrollbar} className={classes.table}>
                                                            <Table aria-label="spanning table" size="small" >
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Informação</TableCell>
                                                                        <TableCell>Valor</TableCell>
                                                                        <TableCell>...</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {infoValues.map((vlr, index) => (
                                                                        <TableRow>
                                                                            <TableCell>{vlr.NOME} {(vlr.OBRIGATORIO == 1 ? '*' : '')}</TableCell>
                                                                            <TableCell align="left" >
                                                                                {(vlr.TIPO_ENTRADA == 1) ?
                                                                                    <TextField
                                                                                        key={index}
                                                                                        fullWidth
                                                                                        required={vlr.OBRIGATORIO == 1}
                                                                                        margin="none"
                                                                                        variant="outlined"
                                                                                        onChange={e => changeItem(e.target.value, index, vlr.TIPO_ENTRADA)}
                                                                                        value={vlr.VALOR}
                                                                                        inputProps={{ maxLength: vlr.TAMANHO_VALOR }}
                                                                                    />
                                                                                    : (vlr.TIPO_ENTRADA == 2) ?
                                                                                        <NumberFormat
                                                                                            key={index}
                                                                                            fullWidth
                                                                                            required={vlr.OBRIGATORIO == 1}
                                                                                            margin="none"
                                                                                            value={vlr.VALOR}
                                                                                            variant="outlined"
                                                                                            onChange={e => changeItem(e.target.value, index, vlr.TIPO_ENTRADA)}
                                                                                            customInput={TextField}
                                                                                            inputProps={{ maxLength: vlr.TAMANHO_VALOR }}
                                                                                        />
                                                                                        : (vlr.TIPO_ENTRADA == 3) ?
                                                                                            <FormControl variant="outlined" fullWidth margin="none">
                                                                                                <Select notched
                                                                                                    key={index}
                                                                                                    autosize={true}
                                                                                                    required={vlr.OBRIGATORIO == 1}
                                                                                                    value={vlr.VALOR}
                                                                                                    variant="outlined"
                                                                                                    onChange={e => changeItem(e.target.value, index, vlr.TIPO_ENTRADA)}
                                                                                                >
                                                                                                    <MenuItem value="null">
                                                                                                        <em>Não Informado</em>
                                                                                                    </MenuItem>
                                                                                                    <MenuItem value="1">
                                                                                                        <em>Sim</em>
                                                                                                    </MenuItem>
                                                                                                    <MenuItem value="0">
                                                                                                        <em>Não</em>
                                                                                                    </MenuItem>
                                                                                                </Select>
                                                                                            </FormControl>
                                                                                            : (vlr.TIPO_ENTRADA == 4) ?
                                                                                                <KeyboardDatePicker
                                                                                                    key={index}
                                                                                                    fullWidth
                                                                                                    required={vlr.OBRIGATORIO == 1}
                                                                                                    cancelLabel="Cancelar"
                                                                                                    margin="none"
                                                                                                    inputVariant="outlined"
                                                                                                    format="DD/MM/YYYY"
                                                                                                    value={vlr.DATA}
                                                                                                    onChange={value => changeItem(value, index, vlr.TIPO_ENTRADA)}
                                                                                                    KeyboardButtonProps={{
                                                                                                        'aria-label': 'change date',
                                                                                                    }}
                                                                                                />
                                                                                                : ""}

                                                                            </TableCell>
                                                                            <TableCell>{vlr.SUFIXO}</TableCell>
                                                                        </TableRow>
                                                                    ))}

                                                                    {(infoValues.length == 0) ?
                                                                        <TableRow>
                                                                            <TableCell colSpan={2}>Nenhuma informação adicional encontrada</TableCell>
                                                                        </TableRow>
                                                                        : ""}

                                                                </TableBody>

                                                            </Table>
                                                        </TableContainer>

                                                    </Paper>

                                                </Grid>
                                            </Grid>

                                        </Grid>

                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <Grid
                                                container
                                                xs="auto"
                                            >

                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}
                                                >

                                                    <Grid
                                                        container
                                                        spacing={1}
                                                        justifyContent="center"
                                                        alignItems="baseline"
                                                        component={Paper}
                                                    >

                                                        <Grid
                                                            item
                                                            md={12}
                                                            xs={12}>
                                                            {(infraDocument) ? (infraDocument.descricao == 'Novo Documento') ?
                                                                (

                                                                    <Tooltip title={`Enviado: ` + moment(infraDocument.dataEnvio).format('DD/MM/yyyy HH:mm')}>
                                                                        <Chip
                                                                            disabled={item.docs.length == 0 || !infraDocument}
                                                                            component={Link}
                                                                            onClick={() => { openDocumentEdition(infraDocument) }}
                                                                            className={classes.doctitle1}
                                                                            label={infraDocument.descricao}
                                                                            variant="outlined"
                                                                            size='small' >
                                                                        </Chip>
                                                                    </Tooltip>
                                                                ) : (

                                                                    <Fragment>
                                                                        <Tooltip title={`Enviado :` + moment(infraDocument.dataEnvio).format('DD/MM/yyyy HH:mm')}>
                                                                            <Link onClick={() => { (!(item.docs.length == 0 || !infraDocument)) ? openDocumentEdition(infraDocument) : {} }}>
                                                                                <Typography
                                                                                    className={classes.doctitle2}
                                                                                    noWrap
                                                                                    variant='h5'>
                                                                                    {(infraDocument.descricao) ? infraDocument.descricao : "Novo Documento"}
                                                                                </Typography>
                                                                            </Link>
                                                                        </Tooltip>
                                                                    </Fragment>
                                                                ) :
                                                                (
                                                                    <Tooltip title={`Enviar Agora :` + moment().format('DD/MM/yyyy HH:mm')}>
                                                                        <Chip className={classes.doctitle1} label="Nenhum Arquivo" variant="outlined" size='small' >
                                                                        </Chip>
                                                                    </Tooltip>
                                                                )}
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={12}
                                                            xs={12}
                                                        >
                                                            <Tooltip title={(infraDocument) ? infraDocument.nome + ` - ` + fileSize(infraDocument.tamanho) : ""}>
                                                                <Box my={1}>
                                                                    <Slide ref={slideRef} {...defaultProperties} autoplay={false} >
                                                                        {(item.docs.length == 0)
                                                                            ?
                                                                            <Box component={Paper} className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.avatar2 : classes.avatar1}
                                                                                onClick={() => { openUpload(values) }}
                                                                                display="flex"
                                                                                justifyContent="center"
                                                                                alignItems="center"
                                                                            >
                                                                                <Typography variant='h4'>
                                                                                    Sem Imagem
                                                                                </Typography>
                                                                            </Box>
                                                                            :
                                                                            item.docs.map((doc, index) =>

                                                                                <object component={Paper}
                                                                                    display="flex"
                                                                                    justifyContent="center"
                                                                                    alignItems="center"
                                                                                    className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.avatar2 : classes.avatar1}
                                                                                    data={process.env.REACT_APP_REMOTE_REPO + '/units/' + doc.unidade + '/' + doc.nome}
                                                                                    type={item.formato}
                                                                                    style={{ objectFit: 'contain', padding: 5, height: '100%', width: '100%' }}
                                                                                >
                                                                                </object>

                                                                            )

                                                                        }
                                                                    </Slide>

                                                                </Box>
                                                            </Tooltip>

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={4}
                                                        >
                                                            <Button
                                                                color="secondary"
                                                                size="medium"
                                                                disabled={item.docs.length == 0}
                                                                children={<ArrowBack />}
                                                                onClick={() => { previous(item) }}
                                                                variant="outlined"></Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={4}
                                                        >
                                                            <Button
                                                                color="secondary"
                                                                size="medium"
                                                                disabled={item.docs.length == 0}
                                                                children={<ArrowForward />}
                                                                onClick={(event) => { next(item) }}
                                                                variant="outlined"></Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={4}
                                                        >
                                                            <Button
                                                                color="secondary"
                                                                size="medium"
                                                                children={<PublishIcon />}
                                                                onClick={() => { openUpload(item) }}
                                                                variant="outlined"></Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={4}
                                                        >
                                                            <Button
                                                                disabled={item.docs.length == 0 || !infraDocument}
                                                                variant="outlined"
                                                                color="secondary"
                                                                target="_blank"
                                                                children={<GetApp />}
                                                                size="medium"
                                                                href={(infraDocument) ? process.env.REACT_APP_REMOTE_REPO + '/units/' + infraDocument.unidade + '/' + infraDocument.nome : "#"}>
                                                            </Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={4}
                                                        >
                                                            <Button
                                                                disabled={item.docs.length == 0 || !infraDocument}
                                                                color="secondary"
                                                                size="medium"
                                                                children={<EditRoundedIcon />}
                                                                onClick={() => { openDocumentEdition(infraDocument) }}
                                                                variant="outlined"></Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={4}
                                                        >
                                                            <Button
                                                                disabled={item.docs.length == 0 || !infraDocument}
                                                                color="secondary"
                                                                size="medium"
                                                                children={<DeleteRoundedIcon />}
                                                                onClick={() => { openDeletion(infraDocument) }}
                                                                variant="outlined"></Button>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={3}>
                                                            <Chip variant='outlined' size='small' className={classes.doctitle3} label={(infraDocument) ? ("( " + (docIndex + 1) + "/" + item.docs.length + " )") : "0/0"} />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            md={4}
                                                            xs={9}>
                                                            <Typography variant='h6' color='secondary' >{(infraDocument) ? ((infraDocument.tipo) ? getName(infraDocument.tipo) : "Tipo Não Informado") : "0/0"}</Typography>
                                                        </Grid>

                                                    </Grid>

                                                </Grid>
                                            </Grid>

                                        </Grid>



                                    </Grid>
                                </Box>

                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Infra;
